/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVectorTriangle: {
  name: 'vector-triangle';
  data: string;
} = {
  name: 'vector-triangle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2c0 .582-.249 1.106-.646 1.472L19.618 17H21a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2H7a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h1.382L9.646 6.472A1.995 1.995 0 0 1 9 5V3ZM7 19h10c0-.582.249-1.107.646-1.472L12.382 7h-.764L6.354 17.528c.397.366.646.89.646 1.472Zm-2 1v1H3v-2h2v1Zm14 0v1h2v-2h-2v1ZM12.978 5H11V3h2v2h-.022Z" fill="currentColor"/></svg>`,
};
